export function reorderArray(arr: string[], priorityList: string[]): string[] {
  const startItems = priorityList.filter(item => arr.includes(item));

  const sortedItems = [...arr].sort();

  // @ts-expect-error - assumptions about es version
  return [...new Set([...startItems, ...sortedItems])];
}
